import React from "react";
import { Label } from "reactstrap";
import CircularLoader from "../../assets/images/icons/circular-spinner.svg";
import DropDown from "../../assets/images/icons/drop-down.svg";

const CoreInvoiceInput = ({
  invoiceTableData,
  setInvoiceTableData,
  options,
  isFetchingServices,
  serviceList,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceTableData((prev) => ({
      ...prev,
      [name]: value,
      //  Add service name and revenue group id if serviceType is changed
      ...(name === "serviceType" && {
        serviceTypeName:
          serviceList.find((service) => service.id === parseInt(value))
            ?.name || "",
        revenueGroupId: serviceList.find(
          (service) => service.id === parseInt(value)
        )?.revenueGroupId,
      }),
    }));
  };

  return (
    <div>
      <Label className="entity-auth-label">Select service type</Label>
      <div className="input-container">
        <select
          className="no-spinner-input entity-auth-label-dropdown"
          type="select"
          name="serviceType"
          value={invoiceTableData?.serviceType}
          onChange={handleChange}
        >
          <option value="" disabled hidden selected>
            Choose an option
          </option>
          {serviceList.map((service, index) => (
            <option key={index} value={service.id}>
              {service.name}
            </option>
          ))}
        </select>
        <img
          src={isFetchingServices ? CircularLoader : DropDown}
          alt="dropdown"
          className={`activity-icon ${isFetchingServices ? "loading" : ""}`}
        />
      </div>
      <div className="input-group">
        <div className="stack">
          <p>Item description</p>
          <p className="middle">Qty</p>
          <p>Amount</p>
        </div>
        <div className="stack">
          <input
            className="no-spinner-input invoice-input"
            type="text"
            name="description"
            value={invoiceTableData?.description}
            onChange={handleChange}
          />
          <input
            className="no-spinner-input invoice-input middle"
            type="number"
            name="quantity"
            value={invoiceTableData?.quantity}
            onChange={handleChange}
          />
          <input
            className="no-spinner-input invoice-input"
            type="number"
            name="amount"
            value={invoiceTableData?.amount}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CoreInvoiceInput;
